// ✅ Trekkin.app — CloseButton.jsx v1.5.0 (SAFE TOAST)
// -------------------------------------------------------------
// ✔ Nunca passa objetos ao toast
// ✔ Totalmente neutro
// -------------------------------------------------------------

import { showToast } from "./NotifyToast.jsx";

export default function CloseButton({ onClick }) {
  const handleClick = () => {
    try {
      if (typeof onClick === "function") onClick();
    } catch (e) {
      showToast({
        type: "error",
        message: "Erro ao fechar painel",
      });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{
        border: "none",
        background: "transparent",
        fontSize: 22,
        cursor: "pointer",
        lineHeight: 1,
      }}
      aria-label="Fechar"
    >
      ✕
    </button>
  );
}
